import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useCallback, useContext } from 'react';
import "../index.css";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import axios from 'axios';
import { FaTag } from 'react-icons/fa';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
function LearnScript() {
  const navigate = useNavigate();
  const location = useLocation();
  // const { LearningId, dayId, methodType, dayName } = location.state || {};
  const [activePage, setActivePage] = useState("");

  const [isActive, setIsActive] = useState(true);
  const [categoryId, setCategoryId] = useState(null);
  const [quizData, setQuizData] = useState([]);
  const [hasQuizData, setHasQuizData] = useState(false);
  const authToken = localStorage.getItem("AuthToken");
  const [marker, setMarker] = useState([]);
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  const { Translate } = useContext(ProductContext);
  const LearScriptData = location.state;
  const LearningId = LearScriptData.LearningId;
  const dayId = LearScriptData.dayId;
  const methodType = LearScriptData.methodType;
  const dayName = LearScriptData.dayName;
  const day_learning_method_id = LearScriptData.day_learning_method_id;
  const examId = LearScriptData.examId;
  const ModuleId = LearScriptData.ModuleId;
  const examTypes = LearScriptData.examTypes;
  const selectedExamId = LearScriptData.selectedExamId;
  console.log("examTypes Learn Script ", examTypes );
  const [isLoadingImage, setIsLoadingImage] = useState(true);
  // const {LearningId, dayId, methodType, dayName} = route.params;
  const [language, setLanguage] = useState('enlish'); // Default to English
  const [titles, setTitles] = useState([]);
  const [translatedTexts, setTranslatedTexts] = useState({
    lectureVideo: 'Lecture Video',
    skit: 'Skit',
    writingPractice: 'Writing Practice',
    takeQuiz: 'Take Quiz',
  });

  const getDayMarker = useCallback(async () => {
    try {
      const response = await fetch(
        `https://api.japaking.online/api/user-visits/visited-status?id=${ModuleId}&learning_method_id=${LearningId}&examId=${examId}`,
        
        
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      const idArray = data.map(item => item.screen_title_id).filter(id => id !== null);

      const uniqueIdArray = [...new Set(idArray)];
      console.log("Filtered array: learning script", uniqueIdArray);

      setMarker(uniqueIdArray);
    } catch (error) {
      console.log("Error getting marker IDs:", error);
    }
  }, [authToken]);

  useEffect(() => {

    getDayMarker();
  }, [getDayMarker]);


  if (isLoadingImage) {

  }


  useEffect(() => {
    const fetchTitles = async () => {
      try {
        const response = await fetch(`https://api.japaking.online/api/screen-title/${LearningId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        const data = await response.json();

        if (data.success) {
          setTitles(data.message.screenTitle);
        }
        else {
          console.log("failed to load titles")
        }
      }
      catch (error) {
        console.log("Error loading titles ", error.message)
      }
    }

    fetchTitles();
  }, [dayId])
  useEffect(() => {
    const loadLanguage = async () => {
      try {
        const storedLanguage = await localStorage.getItem('selectedLanguage');
        if (storedLanguage) {
          setLanguage(storedLanguage);
          updateTranslatedTexts(storedLanguage);
        }
      } catch (error) {
        console.error('Error loading language:', error);
      }
    };

    const updateTranslatedTexts = lang => {
      if (lang === 'hindi') {
        setTranslatedTexts({
          lectureVideo: 'क्लास विडियो',
          skit: 'कहानियों से शब्द सीखें',
          writingPractice: 'लिखने का अभ्यास',
          takeQuiz: 'अभ्यास (प्रशन उत्तर)',
        });
      } else {
        setTranslatedTexts({
          lectureVideo: 'Lecture Video',
          skit: 'Skit',
          writingPractice: 'Writing Practice',
          takeQuiz: 'Take Quiz',
        });
      }
    };

    loadLanguage();
  }, []);

  const handleNavigate = (title, categoryId, screenTitleId, is_review) => {
    //console.log("this is title and categoryId", title, categoryId, is_review, screenTitleId);
    //console.log("this is screenTitleId", screenTitleId)
    let destinationScreen = '';
    if (title === 'Lecture' || title === 'Lecture ' || title === 'पाठ वीडियो') {
      destinationScreen = '/leacture-video';
    } else if (title === 'Quiz' || title === 'Quiz ' || title === "Reading" || title === "Grammer＆Vocab" || title === 'प्रश्न और उत्तर' || title === 'पढ़ना' || title === 'व्याकरण और शब्दावली') {
      destinationScreen = '/take-quiz';
    } else if (title === 'Writing Practice' || title === 'Writing Practice ' || title === 'लिखाई का अभ्यास') {
      destinationScreen = '/PracticePage';
      // } else if (title === 'skit1_Day1' || title === 'Skit1_Day1 ' || title === 'Skit1_Day2' || title === 'Skit2' || title === 'Skit1_Day3' || screenTitleId === '63'|| title === 'नाटक2_दिन 2'|| title === 'नाटक3_दिन 3') {
      //   destinationScreen = '/ModuleSkit';
      // }
    } else if (title === 'FlashCard' || title === 'Flash Card' || title === 'फ्लैशकार्ड') {
      destinationScreen = '/FlashCard';
    }
    else if (title === 'マンガ１' || title === 'マンガ (जापानी कॉमिक्स)') {
      destinationScreen = '/Manga';
    }
    else if (title === 'Listening' || title === 'सुनना') {
      destinationScreen = '/ModuleListening';
    } else if (title === 'にほんのこうこう') {
      destinationScreen = '/ModuleSkit';
    } else {
      destinationScreen = '/ModuleSkit';
      console.log(categoryId, "categoryId Module");
      console.log(dayId, "dayId Module");
    }

    navigate(destinationScreen, {
      state: {
        categoryId: categoryId,
        dayId: dayId,
        unique_day_id: ModuleId,
        ModuleId: ModuleId,
        LearningId: LearningId,
        day_learning_method_id: day_learning_method_id,
        examId,
        is_review,
        methodType: methodType,
        examTypes: examTypes,
        selectedExamId,
        examTypes,
        screenTitleId,
      }
    });

    if (ModuleId) {
      localStorage.setItem("ModuleId", String(ModuleId));
      localStorage.setItem("LearningJourneyActiveModuleId", String(ModuleId));
    }
    if (LearningId) {
      localStorage.setItem("LearningId", String(LearningId));
      localStorage.setItem("LearningJourneyActiveLearningMethodId", String(LearningId));
    }
    if (day_learning_method_id) {
      localStorage.setItem("day_learning_method_id", String(day_learning_method_id));
    }
    if (screenTitleId) {
      localStorage.setItem("screenTitleId", String(screenTitleId));
      localStorage.setItem("LearningJourneyActiveScreenId", String(screenTitleId));
    }
    if (examId) {
      localStorage.setItem("examId", String(examId));
    }
    if (selectedExamId) {
      localStorage.setItem("selectedExamId", String(selectedExamId));
    }
    if (dayName) {
      localStorage.setItem("LearningJourneyActiveModuleName", String(dayName));
    }
  };
  // useEffect(() => {
  //   const unsubscribe = addListener('focus', () => {
  //     setIsActive(true);
  //   });
  //   return unsubscribe;
  // }, [navigation]);

  const [selectedLanguage, setSelectedLanguage] = useState('');
  // const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

  console.log(SelectLanguageLocal, "SelectLanguageLocal")
  useEffect(() => {
    const loadLanguage = async () => {
      try {
        const storedLanguage = localStorage.getItem("selectedLanguage");
        console.log("storedLanguage", storedLanguage);
        if (storedLanguage) {
          setSelectedLanguage(storedLanguage);
        }
      } catch (error) {
        console.error("Error loading language:", error);
      }
    };

    loadLanguage();
  }, []);
const backRoute = location.state?.from || "/day-module";
  console.log("this is learning id ", LearningId)
  return (
      <div className="Profile_Design_Main_Div_11">
      <div className="header_inner">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
             <ArrowBackIosIcon
  className="icon_1"
  onClick={() =>
    navigate("/day-module", {
      replace: true,   // 🔥 important
      state: {
        ModuleId,
        // ModuleNameName: ModuleNameName,
        examId
      },
    })
  }
/>

               
              {/* <ArrowBackIosIcon
  className="icon_1"
  onClick={() => navigate("/learning-journey", { replace: true })}
/> */}
              <h2>{methodType}</h2>
              <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
            </div>
          </div>
        </div>
      </div>

      <div className="container JLPT_Quiz" style={{ marginTop: "75px", marginBottom: "75px", height: "420px", }}>
        <div className="content-box">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                {titles.map((item) => (
                  <button
                    className="learn-script-content"
                    onClick={() => handleNavigate(item.title, item.category_id, item.screen_title_id, item.is_review)}
                    key={item.learn_screen_title_id}
                    style={{ position: "relative" }}
                  >
                    <img
                      src={isLoadingImage ? `${process.env.PUBLIC_URL}/assets/images/loading.png` : item?.image_url}
                      onLoad={() => setIsLoadingImage(false)}
                      onError={() => setIsLoadingImage(false)}
                      alt="Japan Icon"
                      className="learn-script-icon"
                    />
                    <div className="module-text-learn-script">
                      <h2>{item.title}</h2>
                      <p>{item.subtitle}</p>
                      {marker.includes(item.screen_title_id) && (
                        <div
                          style={{
                            position: "absolute",
                            top: 20,
                            right: 20,
                            textAlign: "center",
                          }}
                        >
                          <FaTag color="#ffc0cb" size={20} />
                          <p
                            style={{
                              color: "#ffc0cb",
                              fontSize: 14,
                              fontWeight: '600',
                              marginTop: 4,
                            }}
                          >
                             {Translate?.message?.data?.Learned || "Learned"}
                          </p>
                        </div>
                      )}
                    </div>



                  </button>
                ))}
              </div>

            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default LearnScript;
